/**
 * Wraps useOverlay to hide the native sticky ad when a modal is open.
 * Use this instead of useOverlay in pages/components that open modals directly.
 */
export function useOverlayWithAd() {
  const overlay = useOverlay()
  const baseStore = useBaseStore()

  return {
    create(Component: any, options?: any) {
      const modal = overlay.create(Component, options)
      const originalOpen = modal.open.bind(modal)
      return {
        ...modal,
        open(...args: any[]) {
          baseStore.incrementModalOpen()
          const result = originalOpen(...args)
          void Promise.resolve(result).finally(() => baseStore.decrementModalOpen())
          return result
        },
      }
    },
  }
}
